import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import TrustBadges from "./components/TrustBadges";
import Services from "./components/Services";
import Gallery from "./components/Gallery";
import Partners from "./components/Partners";
import QuoteForm from "./components/QuoteForm";
import Footer from "./components/Footer";
import MobileCTA from "./components/MobileCTA";
import LegalNotice from "./pages/LegalNotice";
import PrivacyPolicy from "./pages/PrivacyPolicy";

const Home = () => {
  return (
    <div className="pb-16 lg:pb-0">
      <Header />
      <Hero />
      <TrustBadges />
      <Services />
      <Gallery />
      <Partners />
      <QuoteForm />
      <Footer />
      <MobileCTA />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/mentions-legales" element={<LegalNotice />} />
          <Route path="/politique-confidentialite" element={<PrivacyPolicy />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
